/**
 * The id of a field's hint/error line, derived from its control's id. A
 * wrapper that passes `controlId` (so Field does not clone the control) points
 * the control's aria-describedby here, and the id convention stays in one place.
 */
export function fieldDescId(controlId: string): string {
  return `${controlId}-desc`;
}
